import React from "react";
import { Spinner } from "components/ui";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useInsideCustomerMobileShellProvider } from "contexts/CustomerMobileShellContext";
import CustomerMobilePageLoader from "./CustomerMobilePageLoader";

const resolveLoader = (customLoader, customerMobile, spinnerClass) => {
  if (customLoader) return customLoader;
  if (customerMobile) {
    return <CustomerMobilePageLoader compact />;
  }
  return <Spinner className={spinnerClass} size={40} />;
};

const DefaultLoading = (props) => {
  const {
    loading,
    children,
    spinnerClass,
    className,
    asElement: Component,
    customLoader,
    customerMobile,
  } = props;

  const loader = resolveLoader(customLoader, customerMobile, spinnerClass);

  return loading ? (
    <Component
      className={classNames(
        !customLoader && !customerMobile && "flex items-center justify-center h-full",
        className
      )}
    >
      {loader}
    </Component>
  ) : (
    <>{children}</>
  );
};

const CoveredLoading = (props) => {
  const {
    loading,
    children,
    spinnerClass,
    className,
    asElement: Component,
    customLoader,
    customerMobile,
  } = props;

  const loader = resolveLoader(customLoader, customerMobile, spinnerClass);

  return (
    <Component className={classNames(loading ? "relative" : "", className)}>
      {children}
      {loading && (
        <div className="w-full h-full bg-white dark:bg-gray-800 dark:bg-opacity-60 bg-opacity-50 absolute inset-0" />
      )}
      {loading && (
        <div
          className={
            customerMobile && !customLoader
              ? "absolute inset-x-3 top-3 z-10"
              : "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10"
          }
        >
          {loader}
        </div>
      )}
    </Component>
  );
};

const Loading = (props) => {
  const customerMobile = useInsideCustomerMobileShellProvider();
  const nextProps = { ...props, customerMobile };

  switch (props.type) {
    case "cover":
      return <CoveredLoading {...nextProps} />;
    default:
      return <DefaultLoading {...nextProps} />;
  }
};

Loading.defaultProps = {
  loading: false,
  type: "default",
  asElement: "div",
};

Loading.propTypes = {
  loading: PropTypes.bool,
  spinnerClass: PropTypes.string,
  type: PropTypes.oneOf(["default", "cover"]),
  customLoader: PropTypes.node,
};

export default Loading;
